<template>
  <v-card>
      <v-card-title>
        <!-- <v-flex xs6>
          <cal-picker data-vv-scope="filterForm" :label="filtersLabel.effDate" v-model="filters.effDate"></cal-picker>
        </v-flex> -->
        <div class="headline">Reserve Category Listing</div>
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-autocomplete :items="clmResCatList" v-model="filters.search" :label="filtersLabel.resCat" item-text="label" item-value="value" clearable></v-autocomplete>
        </v-flex>
      </v-card-title>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="filters.search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.resCatShortDesc }}</td>
          <td class="text-xs-left">{{ convertResAmtPNE(props.item.resAmtPNE) }}</td>
          <td class="text-xs-left">{{ convertPaytRcvy(props.item.paytRcvy) }}</td>
          <td class="text-xs-left">{{ formatBoolean(props.item.chkSI) }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click.native="doNew()">New Reserve Category<v-icon>mdi-plus</v-icon></v-btn>
      <v-dialog v-model="clmResCatDialog" max-width="600px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">Permit Reserve Category for Business Class</span>
          </v-card-title>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 v-if="!newBusClsResCat">
                  <v-subheader class="queryLabel">{{labels.resCatQuery}}</v-subheader>
                  <div class="title">{{clmResCatForm.resCat}}</div>
                </v-flex>
                <v-flex xs12 v-else>
                  <v-autocomplete :label="labels.resCat" v-model="clmResCatForm.resCat" :items="clmResCatList" item-text="label" item-value="value" :error-messages="errors.first('busCls') ? errors.first('busCls') :errors.collect('resCat')" data-vv-name="resCat" :data-vv-as="labels.resCat" v-validate="'required'" :loading="clmResCatLoading"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :label="labels.resAmtPNE" v-model="clmResCatForm.resAmtPNE" :items="resAmtPNEList" item-text="label" item-value="value" data-vv-name="resAmtPNE" :data-vv-as="labels.resAmtPNE" :error-messages="errors.collect('resAmtPNE')" v-validate="'required'"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :label="labels.paytRcvy" v-model="clmResCatForm.paytRcvy" :items="paytRcvyList" item-text="label" item-value="value" data-vv-name="paytRcvy" :data-vv-as="labels.paytRcvy" :error-messages="errors.collect('paytRcvy')" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs4>
                  <v-checkbox :label="labels.chkSI" v-model="clmResCatForm.chkSI"></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
            <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure that you want to delete the selected Permitted Business Class?
      <div class="title">{{deleteBusClsClmResCat}}</div>
      </confirm>
    </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
import { extractMenu } from '@/utils/extract'
export default {
  data() {
    return {
      headers: [
        { text: 'Reserve Category', value: 'resCat' },
        { text: 'Allow Positive/Negative/Either', value: 'resAmtPNE' },
        { text: 'Payment or Recovery', value: 'paytRcvy' },
        { text: 'Check Sum Insured', value: 'chkSI' },
        TableConst.tableActionHeader
      ],
      filtersLabel: {
        resCat: 'Reserve Category',
        resAmtPNE: 'Allow Positive/Negative/Either'
      },
      filters: {
        resAmtPNE: null
      },
      labels: {
        resCatQuery: 'Reserve Category*',
        resCat: 'Reserve Category*',
        resAmtPNE: 'Allow Positive/Negative/Either*',
        paytRcvy: 'Payment or Recovery',
        chkSI: 'Check Sum Insured'
      },
      clmResCatForm: {
        resCat: null,
        busCls: null,
        resAmtPNE: null,
        paytRcvy: '',
        chkSI: null
      },
      resAmtPNEList: [
        { label: 'P - Positive', value: 'P' },
        { label: 'N - Negative', value: 'N' },
        { label: 'E - Either', value: 'E' }
      ],
      paytRcvyList: [
        { label: 'P - Payment', value: 'P' },
        { label: 'R - Recovery', value: 'R' }
      ],
      loading: null,
      newBusCls: false,
      clmResCatList: [],
      clmResCatDialog: false,
      clmResCatLoading: false,
      newBusClsResCat: false,
      menu: [],
      deleteBusClsClmResCat: '',
      promptRemove: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    appID() {
      return this.$store.state.parameters.appID
    },
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu.menu
    }
  },
  methods: {
    async doInit() {
      if (!this.newBusCls) {
        // Review
        await this.fetchData(this.id)
      }
      await this.clmResCatListInit()
    },
    convertResAmtPNE(xResAmtPNE) {
      if (xResAmtPNE === 'P') {
        return 'Positive'
      } else if (xResAmtPNE === 'N') {
        return 'Negative'
      } else {
        return 'Either'
      }
    },
    convertPaytRcvy(xPaytRcvy) {
      if (xPaytRcvy === 'P') {
        return 'Payment'
      } else if (xPaytRcvy === 'R') {
        return 'Recovery'
      }
    },
    async fetchData(xbuscls) {
      this.loading = true
      const apiURI = this.busClsMenu.busClsClmResCats
      let expand = {
        busCls: xbuscls
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((busClsClmResCat) => {
              const convertBusClsClmResCat = {
                resCat: busClsClmResCat.resCat,
                busCls: busClsClmResCat.busCls,
                resCatShortDesc: busClsClmResCat.resCat + ' - ' + busClsClmResCat.resCatShortDesc,
                resAmtPNE: busClsClmResCat.resAmtPNE,
                paytRcvy: busClsClmResCat.paytRcvy,
                chkSI: busClsClmResCat.chkSI
              }
              this.items.push(convertBusClsClmResCat)
            })
          } else {
            this.items = []
          }
        }
        this.loading = false
      }
    },
    doClearFilters() {
      this.filters.resCat = null
      this.filters.busCls = null
      this.filters.resAmtPNE = null
      this.filters.paytRcvy = null
      this.filters.chkSI = null
      this.fetchData(this.id)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(this.id)
        }
      })
    },
    doNew() {
      this.resetMessages()
      this.clmResCatForm.resCat = null
      this.clmResCatForm.busCls = this.id
      this.clmResCatForm.resAmtPNE = null
      this.clmResCatForm.paytRcvy = null
      this.clmResCatForm.chkSI = null
      this.clmResCatDialog = true
      this.newBusClsResCat = true
    },
    async doReview(item) {
      this.newBusClsResCat = false
      const apiURI = this.busClsMenu.busClsClmResCat
      if (apiURI) {
        try {
          const expand = {
            appID: this.appID,
            resCat: item.item.resCat,
            busCls: item.item.busCls
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.clmResCatForm.resCat = data.busClsClmResCat.resCat
            this.clmResCatForm.busCls = data.busClsClmResCat.busCls
            this.clmResCatForm.resAmtPNE = data.busClsClmResCat.resAmtPNE
            this.clmResCatForm.paytRcvy = data.busClsClmResCat.paytRcvy
            this.clmResCatForm.chkSI = data.busClsClmResCat.chkSI
            this.clmResCatDialog = true
            this.menu = extractMenu(result.data._links)
          } else {
            this.$snotify.error('Invalid API URL - Business Class Reserve Category Review')
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Reserve Category Review')
      }
    },
    async clmResCatListInit() {
      const apiURI = this.busClsMenu.clmResCatList
      if (apiURI) {
        try {
          const expand = {
            appId: this.appID
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.clmResCatList = data
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Reserve Category List')
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newBusClsResCat) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doUpdate() {
      const apiURI = this.busClsMenu.busClsClmResCatUpdate
      if (apiURI) {
        this.submitting = true
        try {
          if (this.clmResCatForm.paytRcvy === undefined) {
            this.clmResCatForm.paytRcvy = ''
          }
          const result = await this.$http.put(apiURI, this.clmResCatForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.clmResCatForm.busCls)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Reserve Category Update')
      }
    },
    async doCreate() {
      const apiURI = this.busClsMenu.busClsClmResCatCreate
      if (apiURI) {
        this.submitting = true
        try {
          if (this.clmResCatForm.paytRcvy === null) {
            this.clmResCatForm.paytRcvy = ''
          }
          const result = await this.$http.post(apiURI, this.clmResCatForm)
          const { data } = result
          if (data) {
            // Show message via notify
            this.notify(data)
            await this.fetchData(this.clmResCatForm.busCls)
            this.doClose()
          }
          this.submitting = false
        } catch (err) {
          console.log(err)
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Business Class Reserve Category Create')
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedBusClsClmResCat = data
        this.deleteBusClsClmResCat = data.resCatShortDesc
      }
    },
    async doRemove() {
      const apiURI = this.busClsMenu.busClsClmResCatDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          resCat: this.selectedBusClsClmResCat.resCat,
          busCls: this.id,
          resAmtPNE: this.selectedBusClsClmResCat.resAmtPNE
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Business Class Nature of Loss')
      }
    },
    doClose() {
      this.resetMessages()
      this.clmResCatForm.resCat = undefined
      this.clmResCatForm.resAmtPNE = undefined
      this.clmResCatForm.paytRcvy = undefined
      this.clmResCatForm.chkSI = undefined
      this.clmResCatDialog = false
    }
  },
  mounted() {
    if (this.busCls === 'new') {
      this.newBusCls = true
    } else {
      this.doInit()
    }
  },
  created() {

  },
  props: ['id'],
  mixins: [
    TableConst.default,
    MessageMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
